import { render, staticRenderFns } from "./identityManage.vue?vue&type=template&id=3993ba26&scoped=true&"
import script from "./identityManage.vue?vue&type=script&lang=js&"
export * from "./identityManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3993ba26",
  null
  
)

export default component.exports